@if (layer) {
  <div
    class="layer-item"
    [class.disabled]="layer.disabled"
    [class.selected]="layer.selected"
    (click)="selectLayer(layer)"
    [tabindex]="layer.disabled ? -1 : 0"
    (keydown.enter)="selectLayer(layer)">
    @if (layer.loading === 'LOADING') {
      <mat-spinner [attr.aria-label]="'Loading feature info for layer ' + layer.title" diameter="15" color="primary"></mat-spinner>
    } @else if(layer.loading === 'LOADED') {
      <mat-icon [attr.aria-label]="'Feature info loaded for layer ' + layer.title" svgIcon="check"></mat-icon>
    } @else if(layer.loading === 'FAILED') {
      <mat-icon [tmTooltip]="defaultErrorMessage"
                svgIcon="error"
                class="error"></mat-icon>
    }
    <div [tmTooltip]="layer.title" class="title">
      {{ layer.title }}
      @if (layer.loading === 'LOADED') {
        ({{layer.totalCount}})
      }
    </div>
  </div>
}
